"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackWizardButton = exports.ArrowLeftIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _formik = require("formik");

var _rebrand = require("@lt/components/icons-react/rebrand");

var _context = require("../../context");

var _constants = require("../../constants");

var _utils = require("../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BackWizardButton = function BackWizardButton() {
  var _useCigarette = (0, _context.useCigarette)(),
      _useCigarette$state = _useCigarette.state,
      steps = _useCigarette$state.steps,
      isWizard = _useCigarette$state.isWizard,
      dispatch = _useCigarette.dispatch;

  var _useFormikContext = (0, _formik.useFormikContext)(),
      resetForm = _useFormikContext.resetForm;

  var hide = !(isWizard && (0, _utils.afterDestinationStep)(steps));
  var isBlueButton = (0, _utils.isDestinationStep)(steps) || (0, _utils.isPopularCountriesStep)(steps) || (0, _utils.isMetaregionsStep)(steps);

  var handleClick = function handleClick() {
    if ((0, _utils.isDestinationStep)(steps)) {
      resetForm({
        values: _constants.INITIAL_VALUES_FORMIK
      });
    }

    dispatch((0, _context.backStep)());
  };

  if (hide) return null;
  return /*#__PURE__*/_react["default"].createElement(ArrowLeftIcon, {
    onClick: handleClick,
    $isBlueButton: isBlueButton
  });
};

exports.BackWizardButton = BackWizardButton;
var ArrowLeftIcon = (0, _styledComponents["default"])(_rebrand.ArrowLeft).withConfig({
  displayName: "BackWizardButton__ArrowLeftIcon",
  componentId: "sc-1ung3l3-0"
})(["height:24px;position:fixed;top:0;left:0;margin:20px 16px;z-index:2;path{fill:var(--primary-header-color);}"]);
exports.ArrowLeftIcon = ArrowLeftIcon;